const UrlSegment = {
  url: 'TPATraining'
}

export const tpaActionsPack = {

  url: 'TPATraining',

  Rechazar: {
    verb: 'rechazar la suscripción',
    icon: 'cancel',
    title: 'Rechazo de usuario',
    btnTitle: 'Rechazar',
    apiAction: {
      param: 'Reject',
      // se establece como opcion si debe enviar o no el memberId en la peticion
      isMemberIdRequired: true
    },
    key: 1,

    body: {
      email: null,
      enrollmentId: null
    },

    urlTarget: {
      type: 'query',

      getInit: function (body) {
        return `${UrlSegment.url}/Reject?email=${body?.email}&enrollmentId=${body?.enrollmentId}`;
      },
    }


  },

  Reenviar: {
    verb: 'reenviar el email de inscripción',
    icon: 'forward_to_inbox',
    title: 'Reenvío de usuario',
    btnTitle: 'Reenviar',
    apiAction: {
      param: 'ResendInscriptionMail',
      isMemberIdRequired: true
    },

    body: {
      email: null,
      enrollmentId: null
    },

    urlTarget: {
      type: 'query',

      getInit: function (body) {
        return `${UrlSegment.url}/ResendInscriptionMail?email=${body?.email}&enrollmentId=${body?.enrollmentId}`;
      },
    },

    key: 2
  },

  Inhabilitar: {
    verb: 'Bloquear',
    icon: 'lock',
    title: 'TPA Training Bloqueo de usuario',
    btnTitle: 'Inhabilitar',
    apiAction: {
      param: 'BlockSubscription',
      isMemberIdRequired: true
    },

    body: {
      email: null,
      enrollmentId: null
    },

    urlTarget: {
      type: 'query',

      getInit: function (body) {
        return `${UrlSegment.url}/BlockSubscription?email=${body?.email}&enrollmentId=${body?.enrollmentId}`;
      },
    },


    key: 3
  },
  // Esto deberia ser aprobar 
  Aprobar: {
    verb: 'habilitar',
    icon: 'how_to_reg',
    title: 'Habilitación de usuario',
    btnTitle: 'Habilitar',
    apiAction: {
      param: 'Approve',
      isMemberIdRequired: true
    },

    body: {
      email: null,
      enrollmentId: null
    },

    urlTarget: {
      type: 'query',

      getInit: function (body) {
        return `${UrlSegment.url}/Approve?email=${body?.email}&enrollmentId=${body?.enrollmentId}`;
      },
    },


    key: 4
  },
  //aca falta unblockMember
  Habilitar: {
    verb: 'Desbloquear',
    icon: 'lock_open',
    title: 'Habilitación de usuario',
    btnTitle: 'Desbloquear',
    apiAction: {
      param: 'UnblockMember',
      isMemberIdRequired: false
    },

    body: {
      email: null,
      enrollmentId: null
    },

    urlTarget: {
      type: 'query',

      getInit: function (body) {
        return `${UrlSegment.url}/UnblockMember?email=${body?.email}&enrollmentId=${body?.enrollmentId}`;
      },
    },


    key: 6
  },

  Ver: {
    verb: 'Ver Usuario',
    icon: 'visibility',
    title: 'Ver usuario',
    key: 5
  }


};